"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lantern = void 0;
var Misc_1 = require("./Misc");
var Lantern = (function () {
    function Lantern(p5, lanternImg, depth) {
        var _this = this;
        this.draw = function () {
            _this.p.tint(_this.tint);
            _this.p.image(_this.img, _this.x, _this.y, _this.r, _this.r);
        };
        this.move = function () {
            var xOutOfBounds = _this.x < 0 || _this.x > _this.p.width;
            var yOutOfBounds = _this.y + _this.r < 0 || _this.y > _this.p.height;
            if (xOutOfBounds || yOutOfBounds) {
                _this.reset();
                return;
            }
            _this.x += _this.xSpeed * (0.8 + _this.depth * 0.75);
            _this.y += _this.ySpeed * (0.8 + _this.depth * 0.75);
            _this.xSpeed += Misc_1.getRandom(-0.025, 0.025);
        };
        this.reset = function () {
            _this.y = _this.p.height - 10;
            _this.x = Misc_1.getRandom(5, _this.p.width - 5);
            _this.xSpeed = Misc_1.getRandom(0, 0.05);
            _this.ySpeed = Misc_1.getRandom(-0.2, -0.3);
        };
        this.p = p5;
        this.x = Misc_1.getRandom(0, p5.width);
        this.y = Misc_1.getRandom(0, p5.height);
        this.xSpeed = Misc_1.getRandom(-0.05, 0.05);
        this.ySpeed = Misc_1.getRandom(-0.2, -0.3);
        this.r = 18 * (1 + depth * 0.12);
        this.tint = p5.color(205 + depth * 25);
        this.width = 20;
        this.height = 30;
        this.depth = depth;
        this.img = lanternImg;
    }
    return Lantern;
}());
exports.Lantern = Lantern;
